import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../interfaces';
import { Payout } from '../models/other-payments.model';

@Injectable({ providedIn: 'root' })
export class PayoutService {
  private readonly apiUrl = `${environment.apiUrl}/company/payouts`;

  constructor(private http: HttpClient) {}

  /**
   * Get all payout requests with filters
   * GET /company/payouts
   */
  getPayoutRequests(filters?: {
    status?: string;
    fromDate?: string;
    toDate?: string;
    page?: number;
    limit?: number;
  }): Observable<ApiResponse<Payout[]>> {
    let params = new HttpParams();
    
    if (filters) {
      if (filters.status) params = params.set('status', filters.status);
      if (filters.fromDate) params = params.set('fromDate', filters.fromDate);
      if (filters.toDate) params = params.set('toDate', filters.toDate);
      if (filters.page) params = params.set('page', filters.page.toString());
      if (filters.limit) params = params.set('limit', filters.limit.toString());
    }

    return this.http.get<ApiResponse<Payout[]>>(this.apiUrl, { params });
  }

  /**
   * Get payout by ID
   * GET /company/payouts/:id
   */
  getPayoutById(id: number): Observable<ApiResponse<Payout>> {
    return this.http.get<ApiResponse<Payout>>(`${this.apiUrl}/${id}`);
  }

  /**
   * Update payout status
   * PUT /company/payouts/:id/status
   */
  updatePayoutStatus(
    id: number,
    status: string,
    reason?: string
  ): Observable<ApiResponse<Payout>> {
    return this.http.put<ApiResponse<Payout>>(
      `${this.apiUrl}/${id}/status`,
      { newStatus: status, reason }
    );
  }

  /**
   * Process payout (approve and execute)
   * POST /company/payouts/:id/process
   */
  processPayout(id: number): Observable<ApiResponse<Payout>> {
    return this.http.post<ApiResponse<Payout>>(
      `${this.apiUrl}/${id}/process`,
      {}
    );
  }
}
